/**
 * Staff name helpers (#3408).
 *
 * Pickers show "Etunimi Sukunimi", so they sort by that display name with
 * Finnish collation. The API orders by last name, which looks random once the
 * first name is printed first.
 */

export interface StaffNameLike {
  firstName: string;
  lastName: string;
}

export function staffDisplayName(user: StaffNameLike): string {
  return `${user.firstName} ${user.lastName}`.trim();
}

const collator = new Intl.Collator('fi', { sensitivity: 'base' });

export function sortStaffByDisplayName<T extends StaffNameLike>(users: readonly T[]): T[] {
  return [...users].sort((a, b) => collator.compare(staffDisplayName(a), staffDisplayName(b)));
}

/**
 * The day picker on Tehtävät: schedulable mechanics (#3120) first, then the
 * rest of the staff, both alphabetical. Nobody is hidden; a supervisor can
 * still open a colleague's day.
 */
export function orderStaffForPicker<T extends StaffNameLike & { isSchedulable?: boolean }>(
  users: readonly T[],
): T[] {
  const sorted = sortStaffByDisplayName(users);
  return [
    ...sorted.filter((user) => user.isSchedulable === true),
    ...sorted.filter((user) => user.isSchedulable !== true),
  ];
}
